// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__2h8CC","content":"App_content__3La4L"};